import { styled, useDripsyTheme } from 'dripsy';
import React from 'react';
import { View } from 'react-native';

interface IStyledViewPropsStyle {
  size: number;
}

const StyledView = styled(View)((props: IStyledViewPropsStyle) => {
  // 36 is the size of avatar image in comment view
  return { pl: 36 + props.size };
});

export function CommentViewLeftSpace() {
  const { theme } = useDripsyTheme();

  return <StyledView size={theme.space.$4} />;
}
